export enum BUTTONGROUP_ORIENTATION {
    HORIZONTAL = 'horizontal',
    VERTICAL = 'vertical',
}
